import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getRelatedTerms, selectTerm } from '../actions';

class Related extends Component {

    onClick(term){
        this.props.selectTerm(term.termName, term.age_group);
        this.props.getRelatedTerms(term, this.props.termsList);
    }

    renderImage(term){
        let img;
        const imgSrc = `${this.props.baseUrl}/images/icons/print_${term.file_resource}.png`;
        if (this.props.isIconView){
            return (
                <img className='related-image' src={imgSrc} />
            );
        } else {
            return ( <p/> );
        }
    }

    renderItem(term, index){
        return (
            <div className={this.props.isIconView ? 'icon-related-item' : 'related-item'}
                 key={index}
                 onClick={ () => this.onClick(term)}
            >
                { this.renderImage(term) }
                <span className={this.props.isIconView ? 'icon-related-text' : 'related-text'}>{term.termName}</span>
            </div>
        );
    }

    renderRelatedItems(){
        return _.map(this.props.relatedTermsList, (term, index) => {
            return this.renderItem(term, index);
        });
    }

    render(){
        return(
            <div className={this.props.isIconView ? 'icon-related-div icon-scrolls' : 'related-div scrolls'}>
                { this.renderRelatedItems() }
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        relatedTermsList: state.mathsDictionary.relatedTermsList,
        termsList: state.mathsDictionary.termsList,
        isIconView: state.mathsDictionary.isIconView,
        baseUrl: state.mathsDictionary.baseUrl
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getRelatedTerms,
        selectTerm
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Related);
